<h1 *ngIf="title">{{ title }}</h1>
<p *ngIf="subTitle">{{ subTitle }}</p>
<ng-content></ng-content>